module.exports = "<h1>Hello World</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/micro-components/h1-component/h1.component.html
// module id = 21
// module chunks = 0 1